<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    // The ID of the modal to use with v-b-modal.the-id
    modalId: {
      type: String,
      default: "edit-team-modal",
    },
  },

  data() {
    return {
      name: "",
    };
  },

  computed: {
    // Mapped vuex state
    ...mapGetters(["activeTeam"]),
  },

  methods: {
    async submit() {
      this.put();
    },

    // Update the team and hide the modal
    async put() {
      await this.updateTeam({
        teamId: this.activeTeam.id,
        newName: this.name,
        handle: this.activeTeam.handle,
      });

      this.hide();
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["updateTeam"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Edit Team"
    button-size="sm"
    hide-header-close
  >
    <b-form @submit.stop.prevent="submit">
      <b-form-group label="New Team Name" label-for="team-name">
        <b-form-input
          id="team-name"
          placeholder="New Name"
          v-model="name"
        ></b-form-input>
      </b-form-group>
    </b-form>

    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button variant="primary" type="submit" @click="submit">
          Update Team
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
